<crm-multi-select
  [styleClass]="styleClass + (isError ? ' ng-invalid ng-dirty' : '')"
  [class]="class + (isError ? ' ng-invalid ng-dirty' : '')"
  [label]="isFloatLabel ? 'Филиал' : ''"
  [showClear]="showClear"
  [appendTo]="appendTo"
  [options]="filials"
  [disabled]="disabled"
  [display]="display"
  [sort]="sort"
  [placeholder]="placeholder"
  [(selectedItems)]="selectedFilials"
  (selectedItemsChange)="selectedFilialsChange.emit($event)"></crm-multi-select>
